import React, { useCallback } from 'react';
import TextFieldEngine from './TextFieldEngine';
import {
  currencies,
  defaultCurrency
} from '../../../internal-components/form-builder/currencies';
import InputAdornment from '@material-ui/core/InputAdornment';
import NumberFormat from 'react-number-format';

const NumberFormatCustom = props => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      // isNumericString
    />
  );
};

const NumberFieldEngine = ({
  internalId,
  value,
  setValue,
  required,
  readOnly,
  options,
  uiType,
  ...fieldProps // for future development, know whe have this
}) => {
  const onSetValue = useCallback(
    (input, event) => {
      // const caret = event.target.selectionStart;
      // const element = event.target;
      // window.requestAnimationFrame(() => {
      //   element.selectionStart = caret;
      //   element.selectionEnd = caret;
      // });

      setValue(
        input.replace(/[^\d.]+/g, '')
        // .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
      );
    },
    [setValue]
  );

  const muiInputProps = { InputProps: { inputComponent: NumberFormatCustom } };

  if (uiType === 'currency') {
    const { symbol } =
      options && options.length
        ? currencies[options[0]]
        : currencies[defaultCurrency];

    muiInputProps.InputProps.startAdornment = (
      <InputAdornment position="start">{symbol}</InputAdornment>
    );
  }

  const viewProps = {
    internalId,
    uiType,
    value,
    setValue,
    required,
    readOnly,
    setValue: onSetValue,
    muiInputProps
  };

  return <TextFieldEngine {...viewProps} />;
};

export default NumberFieldEngine;
